/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * The MSAL instance itself is no longer built from static env vars here — it's fetched
 * per-app from RBAC (see src/rbac/msal.js), since the Client ID/Tenant ID now live on the
 * Application record in RBAC (Admin UI -> Applications) instead of esb-admin's own config.
 *
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"],
};
